import OrganizationSettings from './OrganizationSettings';

export default OrganizationSettings;
